module.exports = __webpack_public_path__ + "ac03cf59bfc87939904bd411d4401347.pdf";